import React, { FC } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { AnnouncementEnrollmentsList } from "./AnnouncementEnrollmentsList";

export const ANNOUNCEMENT_UNSEEN_BY_LIST_MODAL_TITLE = "Unseen by";

export interface AnnouncementUnseenByListModalProps {
	onClose: () => void;
	announcementId: number;
	title?: string;
}

export const AnnouncementUnseenByListModal: FC<AnnouncementUnseenByListModalProps> = ({
	onClose,
	announcementId,
	title = ANNOUNCEMENT_UNSEEN_BY_LIST_MODAL_TITLE,
}) => (
	<Dialog open onClose={onClose} maxWidth="md" fullWidth>
		<DialogTitle>{title}</DialogTitle>
		<DialogContent>
			<AnnouncementEnrollmentsList announcementId={announcementId} />
		</DialogContent>
		<DialogActions>
			<Button onClick={onClose}>Close</Button>
		</DialogActions>
	</Dialog>
);
